@if (showBrowserWarning) {
<div class="browser-warning">
  <span>⚠️ This application is optimized for Google Chrome. Please use Chrome for the best experience.</span>
  <div class="close-btn" (click)="dismissBrowserWarning()">×</div>
</div>
}

@if (loading$ | async) {
<div class="page-loader">
  <p-progressSpinner ariaLabel="loading" strokeWidth="4" />
</div>
}

@if(!initializing) {
<router-outlet></router-outlet>
}

<p-toast position="top-right"></p-toast>

<app-ai-chatbot></app-ai-chatbot>